import type { ObservationLite } from "@/entities/observation";

import uniq from "lodash/uniq";

export const getObservationsInitialSeverityValue = (
  observations: ObservationLite[]
) => {
  const severities = uniq(observations.map((o) => o.severity));

  if (severities.length !== 1) return undefined;

  return severities[0] ?? undefined;
};
